// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___ce189125486f5b1f09f","cls2":"ImpactHubModal-cls2__ce0c36f583adf309b3d6 ImpactHubModal-cls1___ce189125486f5b1f09f"};